import React from 'react';
import Button from '../buttons/SimpleButton/Button';
import Icon from '../../common/components/Icon';
import { useTranslations } from '../../localization/useTranslations';

export function InformationBox() {
  const translations = useTranslations();

  return (
    <div className="print-information-box">
      <Icon name={'f-circle'} size={'large'} />

      <p className="print-information-box__text">
        {translations?.printCategory?.subscriptionBoxDescription || 'Looking for articles from Forbes print magazine?'}
      </p>

      <Button
        className="print-information-box__button"
        href={window?.printPageLink || '#'}
        size="medium"
        type="secondary"
        label={translations?.printCategory?.readMoreButton || 'Read more'}
      />
    </div>
  );
}

export default InformationBox;
